<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import Vue from 'vue'
import QS from 'qs'

// 常量提取
const USER_ICON = {
  LOGGED_IN: require('./assets/icon/user2.png'),
  LOGGED_OUT: require('./assets/icon/user1.png')
}

const LOGIN_STATUS = {
  LOGGED_IN: '1',
  LOGGED_OUT: '0'
}

export default {
  name: 'App',
  data() {
    return {
      userIcon: '',
      appid: '',
      accessToken: ''
    }
  },
  created() {
    this.initApp()
  },
  methods: {
    /**
     * 初始化应用
     */
    initApp() {
      this.handleAuthStatus()
      this.appLog('首页')
    },

    /**
     * 处理认证状态
     */
    handleAuthStatus() {
      const accessToken = this.getQueryString('access_token')
      
      if (accessToken) {
        this.setLoggedInState(accessToken)
      } else {
        this.setLoggedOutState()
      }
      
      this.userIcon = this.$root.common.usericon
    },

    /**
     * 设置登录状态
     * @param {string} token - 访问令牌
     */
    setLoggedInState(token) {
      localStorage.setItem('access_token', token)
      localStorage.setItem('isLogin', LOGIN_STATUS.LOGGED_IN)
      this.$root.common.usericon = USER_ICON.LOGGED_IN
      this.accessToken = token
    },

    /**
     * 设置登出状态
     */
    setLoggedOutState() {
      localStorage.setItem('access_token', '')
      localStorage.setItem('isLogin', LOGIN_STATUS.LOGGED_OUT)
      this.$root.common.usericon = USER_ICON.LOGGED_OUT
    },

    /**
     * 导航回首页
     */
    onClickLeft() {
      this.$router.push({ path: '/' })
    },

    /**
     * 应用日志记录
     * @param {string} module - 模块名称
     */
    async appLog(module) {
      console.log('app date collection')
      
      try {
        const data = QS.stringify({
          requestsource: '公众号',
          customerid: '',
          moudel: module
        })
        
        const config = {
          method: 'post',
          url: this.global.BASE_URL_T3 + '/api/pdsm/logforsvchome',
          headers: {
            'Authorization': this.accessToken || '',
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          data
        }
        
        const response = await Vue.axios(config)
        console.log(response)
      } catch (error) {
        console.error('日志记录失败:', error)
      }
    },

    /**
     * 获取所有响应头信息
     * @returns {Object} 响应头对象
     */
    getHeaders() {
      console.log("get header start here")
      const req = new XMLHttpRequest()
      req.open('GET', document.location.href, false)
      req.send(null)
      
      const headerArr = req.getAllResponseHeaders().split('\n')
      const headers = {}
      
      headerArr.forEach(item => {
        if (item) {
          const index = item.indexOf(':')
          const key = item.slice(0, index)
          const value = item.slice(index + 1).trim()
          headers[key] = value
        }
      })
      
      console.log("headers", JSON.stringify(headers))
      return headers
    },

    /**
     * 从URL参数中获取指定值
     * @param {string} key - 参数键名
     * @returns {string|null} 参数值
     */
    getQueryString(key) {
      const hashPart = window.location.hash.split("?")[1]
      if (!hashPart) return null

      const reg = new RegExp(`(^|&)${key}=([^&]*)(&|$)`)
      const match = hashPart.match(reg)
      
      return match ? decodeURIComponent(match[2]) : null
    },

    /**
     * 获取产品信息
     */
    async getProductsInfo() {
      try {
        const url = `${this.global.BASE_URL_T3}/api/web2/printersinfo?sns=${this.sns}&keyword=${this.keyword}`
        const response = await Vue.axios.get(url)
        
        console.log(response, 'res')
        
        if (response.data.Status === '0') {
          global.devicesList = response.data.Data
          console.log(this.devicesList, 'deviceList')
        } else {
          this.devicesList[0].ProductName = '暂时没有匹配到产品信息'
        }
      } catch (error) {
        console.error('获取产品信息失败:', error)
      }
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0;
  margin-right: auto;
  margin-bottom: 0;
  margin-left: auto;
  background-color: white;
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  width: 120px;
  height: 120px;
  background-color: #fff;
}

.usericon {
  width: 48px;
}
</style>